import { defineStore } from 'pinia'

export const useOrderPaymentStore = defineStore('orderPaymentStore', () => {
  const selectedPaymentMethod = ref('bacs')
  const availablePaymentMethods = ref([
    {
      id: 'bacs',
      title: 'Havale/EFT',
      description: 'Banka havalesi veya EFT ile ödeme yapın',
      icon: 'i-heroicons-building-library'
    },
    {
      id: 'credit_card',
      title: 'Kredi Kartı',
      description: 'Kredi kartı ile güvenli ödeme yapın',
      icon: 'i-heroicons-credit-card',
      disabled: true
    }
  ])

  // Ödeme yöntemini değiştir
  const setPaymentMethod = (method) => {
    selectedPaymentMethod.value = method
  }

  // Ödeme yöntemini doğrula
  const validatePaymentMethod = () => {
    const method = availablePaymentMethods.value.find(
      (m) => m.id === selectedPaymentMethod.value
    )
    return method && !method.disabled
  }

  return {
    // State
    selectedPaymentMethod,
    availablePaymentMethods,

    // Actions
    setPaymentMethod,
    validatePaymentMethod
  }
})
